
/**
 * The function `isCoordinateInsideRectangle` checks if a given coordinate is inside a specified
 * rectangle.
 * @param coordinate - The `coordinate` parameter represents a point on a 2D plane with `x` and `y`
 * values. It is the point you want to check if it lies inside a rectangle.
 * @param rect - The `rect` parameter represents a rectangle and should have the following properties: {x, y, w, h}, where w is width of rectangle and h is height of the rectangle
 * @returns The function `isCoordinateInsideRectangle` returns `true` if the given coordinate is inside
 * the specified rectangle, and `false` otherwise.
 */
export const isCoordinateInsideRectangle = (coordinate, rect) => {
    const {x: rectX, y: rectY, h: rectH, w: rectW} = rect;
    const {x, y} = coordinate;

    if([rectX, rectY, rectH, rectW, x, y].includes(undefined)) throw new Error(`Required coordinates, height or width are missing!\n${JSON.stringify({rect, coordinate})}`);

    if(x > rectX && x < rectX + rectW && y > rectY && y < rectY + rectH) return true;

    return false;
}

/**
 * The function `isRectangleContained` checks if one rectangle is completely contained within another
 * rectangle.
 * @param rectA - The `isRectangleContained` function you provided checks if one rectangle (rectA) is
 * completely contained within another rectangle (rectB).
 * @param rectB 
 * @returns The function `isRectangleContained` is returning a boolean value indicating whether the
 * rectangle represented by `rectA` is completely contained within the rectangle represented by
 * `rectB`.
 */
export const isRectangleContained = (rectA, rectB) => {
    const [ax, ay, aw, ah] = [rectA.attr('x'), rectA.attr('y'), rectA.attr('width'), rectA.attr('height')];
    const [bx, by, bw, bh] = [rectB.attr('x'), rectB.attr('y'), rectB.attr('width'), rectB.attr('height')];
  
    // Check if rectA is completely inside rectB
    return (
      ax >= bx &&                 // Left edge of A is inside B
      ay >= by &&                 // Top edge of A is inside B
      ax + aw <= bx + bw &&       // Right edge of A is inside B
      ay + ah <= by + bh          // Bottom edge of A is inside B
    );
}
  